import { Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IStorageRequestProps } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { StorageRequestDocumentDialog } from "../StorageRequestDocumentDialog";

export const StorageRequestDetailForm: React.FC<IStorageRequestProps> = ({
    storageRequest,
    onUpdate,
    readonly,
    saving,
    ...props
}) => {

    useEffect(() => {
        setStorageReason(storageRequest?.reasonForStorage ?? "");
    }, [storageRequest?.reasonForStorage])

    const [storageReason, setStorageReason] = useState(storageRequest?.reasonForStorage ?? "");


    const handleChange = (property: string, value: any) => {
        setStorageReason(value);
        onUpdate(property, value);
    }

    return (
        <Card sx={{ height: "100%" }} >
            <FormSectionHeader label="Storage Request Details" saving={saving} />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={8} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            multiline
                            rows={3}
                            label="Reason for Storage"
                            value={storageReason}
                            onChange={(e) => handleChange("reasonForStorage", e.currentTarget.value)}
                            helperText="What is the reason for storage"
                            disabled={readonly}
                            required
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <StorageRequestDocumentDialog
                            documents={storageRequest?.documents ?? []}
                            onChanged={(documents) => { console.log("documents", documents); }}
                            readonly={readonly}
                            entityId={storageRequest?.storageRequestId ?? undefined}

                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}